import { render } from "./AansprekingView.vue?vue&type=template&id=1d2ea083"
import script from "./AansprekingView.vue?vue&type=script&lang=js"
export * from "./AansprekingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__